<template>
  <div>
    <Heading
      v-if="headline.text"
      color="blue"
      weight="normal"
      class="mb-8 xl:mb-14"
    >
      {{ headline.text}}
    </Heading>

    <div class="flex flex-col items-start gap-4">
      <DownloadLinkComponent
        v-for="download in mapNodes(downloads)"
        :key="download['@id']"
        :download="download?.download"
      ></DownloadLinkComponent>
    </div>
  </div>
</template>

<script setup>
import DownloadLinkComponent from "./DownloadLinkComponent";
import { mapNodes } from "~/utils/helper/magnolia";
import { Heading } from "~/components/clarity-ui/Heading";
</script>
<script>
export default {
  name: "DownloadListComponent",
  props: ["headline", "downloads"],
};
</script>
